import React from 'react'
import BaseIcon from 'react-icon-base'

const Clone = ({ pathProps, ...props }) => (
  <BaseIcon width="15" height="15" viewBox="0 0 15 15" {...props}>
    <path
      fill="#A8B4C1"
      fillRule="evenodd"
      d="M13 10h-1V3H5V2h8v8zM2 13h8V5H2v8zM3 0v3H0v12h12v-3h3V0H3z"
      opacity=".7"
    />
  </BaseIcon>
)

export default Clone
